module.exports = __webpack_public_path__ + "static/media/source.167afa4d.svg";